import { createContext, useContext } from "react";
import type { LocaleDef } from "./locales";

/**
 * Minimal locale context (Story 4.1) — the active `LocaleDef` for the current
 * `/:lang/…` subtree, or `null` outside any `LocaleLayout` (the sandbox routes
 * that sit above `:lang`). Pure data only: `code / htmlLang / market / name /
 * status`. No `t`, no `dir`, no i18next.
 *
 * This is the seam Story 4.2's `useLocale()` will extend/wrap (adding `t`, `dir`
 * and the i18next instance) — keep this hook's surface stable and data-only.
 */
export const LocaleContext = createContext<LocaleDef | null>(null);

/** The active locale, or `null` when rendered outside a `:lang` subtree (sandbox). */
export function useActiveLocale(): LocaleDef | null {
  return useContext(LocaleContext);
}
